export enum Channels {
  alert = 'alert-event',
}